var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleFilledWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4303 12C21.4303 6.80014 17.1994 2.5712 12.0008 2.5712C6.80215 2.5712 2.57132 6.80014 2.57132 12C2.57132 17.1983 6.80215 21.4288 12.0008 21.4288C17.1994 21.4288 21.4303 17.1983 21.4303 12ZM23 12C23 18.0742 18.0754 23 12.0008 23C5.92462 23 1 18.0742 1 12C1 5.92585 5.92462 1 12.0008 1C18.0754 1 23 5.92585 23 12ZM12.0008 8.07199C12.6518 8.07199 13.1793 7.54298 13.1793 6.89201C13.1793 6.24104 12.6518 5.71361 12.0008 5.71361C11.3498 5.71361 10.8223 6.24104 10.8223 6.89201C10.8223 7.54298 11.3498 8.07199 12.0008 8.07199ZM12.7862 15.928H14.3575V17.4992H9.64355V15.928H11.2149V11.2144H9.64355V9.64319H12.7862V15.928Z",
    fill: "#066FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleFilledWhite);
export default __webpack_public_path__ + "static/media/info-circle-filled-white.2efd3e450737c8c143ed13de1d9a0eb6.svg";
export { ForwardRef as ReactComponent };